import React, { Component } from 'react';
import * as $ from 'jquery';
import brandLogo from '../images/brand-logo-inverse-light.png';
import lang_en from '../images/lang_en.png';
import lang_es from '../images/lang_es.png';
import { LANG } from '../App.js';
import { Link } from 'react-router-dom';
import { SECTION } from '../onboarding/OnboardingContainer.js';
import { translate } from 'react-i18next';

class Navbar extends Component {

  handleContractClick = () => {
    $('#contract')[0].click();
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        {window.location.pathname != '/store' || window.screen.width > 768
          ? (<nav className="navbar navbar-default navbar-fixed-top">
            <div className="navbar-header">
              <div className="navbar-brand">
                <Link className="nav-link" to="/">
                <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                </Link>
              </div>
              <ul className="nav navbar-top-links navbar-right">
                <li className="nav-movil">
                  <a onClick={this.props.handleLanguageChange}>
                    <img
                      alt={t('guest.img_lang')}
                      src={this.props.lang === LANG.EN ? lang_es : lang_en}
                      width="20px" />
                  </a>
                </li>
              </ul>
            </div>
            <ul className="nav navbar-top-links navbar-right nav-desktop">
              <li>
                <a onClick={this.props.handleLanguageChange}>
                  <img
                    alt={t('guest.img_lang')}
                    src={this.props.lang === LANG.EN ? lang_es : lang_en}
                    width="20px" />
                </a>
              </li>
              <li>
                <Link className="nav-link" to="/onboarding">
                  {t('guest.navbar.login')}
                </Link>
              </li>
              <li>
                <Link className="nav-link" to={{ pathname: "/onboarding", state: { section: SECTION.SIGNUP } }}>
                  {t('guest.navbar.signup')}
                </Link>
              </li>
              {/*<li className="hidden-xs">
          <a id="contract" className="hidden" href="https://iosfera.iosoffices.com/planes-ios-offices-contratar" rel="noopener noreferrer" target="_blank">
            {t('guest.navbar.contract')}
          </a>
          <button className="btn btn-outline" onClick={this.handleContractClick}>
            <span>{t('guest.navbar.contract')}</span>
          </button>
  </li>*/}
            </ul>
          </nav>)
          : null

        }

      </div>
    );
  }
}

export default translate('common')(Navbar);



// WEBPACK FOOTER //
// ./src/guest/Navbar.js